const INACTIVITY_THRESHOLD_MS = 2 * 60 * 60 * 1000; // 2 hours
const LAST_ACTIVITY_KEY = "lastActivityTimestamp";

/**
 * Updates the last activity timestamp in sessionStorage
 */
export const updateLastActivity = (): void => {
  sessionStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString());
};

/**
 * Checks if the session is stale based on inactivity threshold
 * @returns true if session is stale and should be refreshed
 */
export const isSessionStale = (): boolean => {
  const lastActivity = sessionStorage.getItem(LAST_ACTIVITY_KEY);

  if (!lastActivity) {
    // No activity recorded yet, mark as fresh
    updateLastActivity();
    return false;
  }

  const inactiveTime = Date.now() - parseInt(lastActivity, 10);
  return inactiveTime > INACTIVITY_THRESHOLD_MS;
};

/**
 * Sets up a page visibility listener that reloads the page if session is stale
 * @returns cleanup function to remove the listener
 */
export const setupSessionFreshnessCheck = (): (() => void) => {
  updateLastActivity();

  const handleVisibilityChange = () => {
    if (document.visibilityState === "visible") {
      if (isSessionStale()) {
        console.log("Session stale, reloading page...");
        window.location.reload();
      } else {
        // Update activity timestamp when user returns to tab
        updateLastActivity();
      }
    }
  };

  document.addEventListener("visibilitychange", handleVisibilityChange);

  return () => {
    document.removeEventListener("visibilitychange", handleVisibilityChange);
  };
};
